export default __webpack_public_path__ + "static/media/icon02.5bfc63b0.svg";